import { Mail } from 'lucide-react';

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@design-system';

const SUPPORT_EMAIL = 'support@wealthassurancegroup.com';

interface RequestHelpDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RequestHelpDialog({ open, onOpenChange }: RequestHelpDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <div className="bg-primary/10 mx-auto mb-2 flex size-12 items-center justify-center rounded-full">
            <Mail className="text-primary size-6" />
          </div>
          <DialogTitle className="text-center">Need help finding the right plan?</DialogTitle>
          <DialogDescription className="text-center">
            Send an email describing what you’re looking for to connect with a licensed agent,
            review your options, and receive quotes. Licensed support is provided through Wealth
            Assurance Group, a Waterlily company.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 pt-2">
          <div className="bg-muted rounded-lg border p-4 text-center">
            <a
              href={`mailto:${SUPPORT_EMAIL}?subject=Help finding insurance options`}
              className="text-primary text-lg font-semibold hover:underline"
            >
              {SUPPORT_EMAIL}
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
